export default __webpack_public_path__ + "static/healthcare-26a1ffcaff0aee757498d2fc06bd9355.webp";